import React from "react";
import HeaderMobile from "./HeaderMobile/headerMobile";
import HeaderDesktop from "./HeaderDesktop/headerDesktop";
import styles from "./header.module.scss";

const headerItems = [
  {
    key: 'how_it_works',
    href: {
      de: `${process.env.HOMEPAGE_URL}/de/how-it-works`,
      en: `${process.env.HOMEPAGE_URL}/how-it-works`,
      es: `${process.env.HOMEPAGE_URL}/es/how-it-works`,
      fr: `${process.env.HOMEPAGE_URL}/fr/how-it-works`,
      it: `${process.env.HOMEPAGE_URL}/it/how-it-works`,
      nl: `${process.env.HOMEPAGE_URL}/nl/how-it-works`,
      pl: `${process.env.HOMEPAGE_URL}/pl/how-it-works`,
      pt: `${process.env.HOMEPAGE_URL}/pt/how-it-works`,
      zh: `${process.env.HOMEPAGE_URL}/zh/how-it-works`,
    }
  },
  { key: 'get_support', href: 'https://find.uniplaces.com/find-accommodation-europe/' },
  { key: 'help', href: 'https://help.uniplaces.com/help/s' },
  { key: 'list_your_place', href: process.env.SS_URL }
];

const Header = ({ locale }) => (
  <React.Fragment>
    <div className={styles.headerDesktop}>
      <HeaderDesktop headerItems={headerItems} locale={locale} />
    </div>
    <div className={styles.headerMobile}>
      <HeaderMobile headerItems={headerItems} locale={locale} />
    </div>
  </React.Fragment>
);

export default Header;
